import HU from './HUPlanStepBehaviours.json';
import AT from './ATPlanStepBehaviours.json';
import BG from './BGPlanStepBehaviours.json';
import DE from './DEPlanStepBehaviours.json';
import FR from './FRPlanStepBehaviours.json';
import RO from './ROPlanStepBehaviours.json';
import UK from './UKPlanStepBehaviours.json';
import CZ from './CZPlanStepBehaviours.json';
import SK from './SKPlanStepBehaviours.json';

export default { HU, AT, BG, DE, FR, RO, UK, CZ, SK };
